import type { HelpFile } from '../../types/help'
import { SystemGrantsDetailTestIds } from '../../../testids/SystemGrantsDetailTestIds'

export const systemGrantsDetailHelp: HelpFile = {
  docPage: '/docs/access-analytics/system-grants',
  texts: {
    [SystemGrantsDetailTestIds.systemGrantsDetailPage]:
      'Effektive Zugriffsberechtigungen eines Zielsystems — Gesamtzahlen und Quellenaufschlüsselung pro Berechtigung.',
    [SystemGrantsDetailTestIds.cardTitleActiveGrants]:
      'Anzahl derzeit aktiver Berechtigungen auf diesem System.',
    [SystemGrantsDetailTestIds.cardTitleEffectiveAccessGrants]:
      'Effektive Zugriffsberechtigungen, aufgeschlüsselt nach Identität, Ressource und Operation.',
    [SystemGrantsDetailTestIds.cardTitleTotalGrants]:
      'Gesamtzahl berechneter Berechtigungen auf diesem System — einschließlich abgelaufener und ausstehender Einträge.',
    [SystemGrantsDetailTestIds.cardTitleUniqueIdentities]:
      'Anzahl verschiedener Identitäten mit mindestens einer effektiven Berechtigung auf diesem System.',
    [SystemGrantsDetailTestIds.colEnforcementObject]:
      'Enforcement-Objekt, dessen Zugriffsrecht durch diese Berechtigung umgesetzt wird.',
    [SystemGrantsDetailTestIds.colExpand]:
      'Erweitert die Zeile, um die zur Berechtigung beitragenden Quell-Zuweisungen anzuzeigen.',
    [SystemGrantsDetailTestIds.colIdentity]:
      'Identität, die diese Berechtigung hält.',
    [SystemGrantsDetailTestIds.colOperation]:
      'Auf der Ressource erlaubte Operation (Lesen, Schreiben, Ausführen usw.).',
    [SystemGrantsDetailTestIds.colResource]:
      'Ressource, auf die sich diese Berechtigung bezieht.',
    [SystemGrantsDetailTestIds.colSourceAccessProfile]:
      'Zugriffsprofil, das zu dieser Berechtigung beiträgt.',
    [SystemGrantsDetailTestIds.colSourceAssignmentExpires]:
      'Ablaufdatum der Quell-Zuweisung, falls vorhanden.',
    [SystemGrantsDetailTestIds.colSourceAssignmentStart]:
      'Startdatum der Quell-Zuweisung.',
    [SystemGrantsDetailTestIds.colSourceCreatedAt]:
      'Zeitstempel der Erstellung der Quell-Zuweisung.',
    [SystemGrantsDetailTestIds.colStatus]:
      'Aktueller Status der Berechtigung (aktiv, ausstehend, abgelaufen, widerrufen).',
    [SystemGrantsDetailTestIds.colValidFrom]:
      'Datum, ab dem diese Berechtigung gültig ist.',
    [SystemGrantsDetailTestIds.colValidTo]:
      'Datum, bis zu dem diese Berechtigung gültig ist.',
    [SystemGrantsDetailTestIds.filterIdentity]:
      'Berechtigungen auf eine bestimmte Identität einschränken.',
    [SystemGrantsDetailTestIds.filterOperation]:
      'Berechtigungen nach Operationstyp einschränken.',
    [SystemGrantsDetailTestIds.linkSystemDetail]: null,
  },
}
